import { render, staticRenderFns } from "./TabAccountDetails.vue?vue&type=template&id=150cee08&"
import script from "./TabAccountDetails.js?vue&type=script&lang=js&"
export * from "./TabAccountDetails.js?vue&type=script&lang=js&"
import style0 from "./TabAccountDetails.scss?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./TabAccountDetails.txt?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2Fcomponents%2Fuseraccount%2FTabAccountDetails%2FTabAccountDetails.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports